import { useState } from "react";
import LeftMenu from "./LeftMenu";
import ParentTopBar from "./ParentTopBar";
import { useAuth } from "../../contexts/AuthContext";
import Modal from "../../common/Modal";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../contexts/CartContext";
import {
  useChildDetails,
  useDisclaimer,
  useMealsSelection,
  useMealType,
} from "../../contexts/SubscriptionContext";

const Wrapper = ({ component, goBack }) => {
  const [state, setState] = useState({
    menuActive: "Dashboard",
    mobileMenuOpen: false,
  });
  const navigate = useNavigate();
  const { isLoggedIn, signOut } = useAuth();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const { fetchCart } = useCart();

  const handleMenu = (value) =>
    setState((prev) => ({ ...prev, menuActive: value }));

  const toggleMobileMenu = () =>
    setState((prev) => ({ ...prev, mobileMenuOpen: !prev.mobileMenuOpen }));
  const { setSelectedMealType } = useMealType();
  const { clearMeals } = useMealsSelection();
  const { clearChildDetails } = useChildDetails();
  const { resetDisclaimer } = useDisclaimer();
  // Logout confirm handler
  const handleConfirmLogout = async () => {
    setShowLogoutModal(false);
    await signOut();
    setSelectedMealType(null);
    clearMeals();
    clearChildDetails();
    resetDisclaimer();
    await fetchCart();
    navigate("/");
  };

  return (
    <>
      {isLoggedIn ? (
        <div className="grid xl:grid-cols-[1fr_4.06fr] gap-8 relative">
          {/* Mobile menu overlay */}
          {state.mobileMenuOpen && (
            <div
              className="fixed inset-0 bg-black/20 z-[40] xl:hidden"
              onClick={toggleMobileMenu}
            />
          )}

          {/* Left menu mobile */}
          <div
            className={`fixed top-0 left-0 h-full w-[280px] bg-white shadow-lg z-[50]
              transform transition-transform duration-300 xl:hidden
              ${state.mobileMenuOpen ? "translate-x-0" : "-translate-x-full"}
            `}
          >
            <div className="sticky top-0 mt-[180px] p-4 z-[50]">
              <LeftMenu
                onChange={handleMenu}
                active={state.menuActive}
                onLogout={() => setShowLogoutModal(true)}
              />
            </div>
          </div>

          {/* Left menu desktop */}
          <div className="hidden xl:block xl:sticky xl:top-0 2.5xl:mt-[165px]">
            <LeftMenu
              onChange={handleMenu}
              active={state.menuActive}
              onLogout={() => setShowLogoutModal(true)}
            />
          </div>

          {/* Right content */}
          <div className="rounded-[15px]">
            <div>
              <div className="min-h-[500px]">
                <ParentTopBar onMenuClick={toggleMobileMenu} goBack={goBack} />
                {component}
              </div>
            </div>
          </div>

          {/* Logout Confirmation Modal (on top of all) */}
          {showLogoutModal && (
            <Modal
              isOpen={showLogoutModal}
              onClose={() => setShowLogoutModal(false)}
              title="Confirm Logout"
              onConfirm={handleConfirmLogout}
            >
              <div className="font-mono">
                <p className="text-gray-700 mt-3">
                  Are you sure you want to log out of your account?
                </p>
              </div>
            </Modal>
          )}
        </div>
      ) : (
        <>{component}</>
      )}
    </>
  );
};

export default Wrapper;
